
import { BouncesResponse } from './types/bounces'
import { createApi, FetchArgs } from '@reduxjs/toolkit/query/react'
import { baseQuery } from "./default";

interface QueryOpts {
  limit?: number
  offset?: number
}


// Define a service using a base URL and expected endpoints
export const BouncesApi = createApi({
  reducerPath:'apiBounces',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getBounces: builder.query<BouncesResponse, QueryOpts>({
      query: (opts: QueryOpts) => {
        let u =  `api/bounces/`
        if(opts.limit) {
          u += '?limit=' + opts.limit
        }
        if(opts.offset) {
          u += "&offset=" + opts.offset
        }
        return u
      },
    }),
  }),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetBouncesQuery,  } = BouncesApi;
